import { createClient } from '@supabase/supabase-js'
const RECOVERY_FLAG_KEY = 'supabase_recovery_pending'

function captureRecoveryMode() {
  try {
    const hash = window.location.hash
    if (hash) {
      const params = new URLSearchParams(hash.substring(1))
      if (params.get('type') === 'recovery') {
        sessionStorage.setItem(RECOVERY_FLAG_KEY, 'true')
        return
      }
    }
  } catch {
    // Ignore
  }
  sessionStorage.removeItem(RECOVERY_FLAG_KEY)
}

// Must be called BEFORE createClient
captureRecoveryMode()

export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
  }
)

export function isRecoveryPending(): boolean {
  try {
    return sessionStorage.getItem(RECOVERY_FLAG_KEY) === 'true'
  } catch {
    return false
  }
}

export function clearRecoveryFlag(): void {
  try {
    sessionStorage.removeItem(RECOVERY_FLAG_KEY)
  } catch {
    // Ignore
  }
}